import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CalendarIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M4.83333 4.00031V1.33331C4.83333 1.05717 5.05719 0.833313 5.33333 0.833313C5.60947 0.833313 5.83333 1.05717 5.83333 1.33331V4.00031C5.83316 4.2763 5.60937 4.50031 5.33333 4.50031C5.0573 4.50031 4.83351 4.2763 4.83333 4.00031Z"
      fill="currentColor"
    />
    <path
      d="M10.1667 4.00031V1.33331C10.1667 1.05717 10.3905 0.833313 10.6667 0.833313C10.9428 0.833313 11.1667 1.05717 11.1667 1.33331V4.00031C11.1665 4.2763 10.9427 4.50031 10.6667 4.50031C10.3906 4.50031 10.1668 4.2763 10.1667 4.00031Z"
      fill="currentColor"
    />
    <path
      d="M13.5 3.99969C13.4998 3.53972 13.127 3.16686 12.667 3.16669H3.33301C2.87303 3.16686 2.50018 3.53972 2.5 3.99969V13.3337C2.50018 13.7937 2.87303 14.1665 3.33301 14.1667H12.667C13.127 14.1665 13.4998 13.7937 13.5 13.3337V3.99969ZM14.5 13.3337C14.4998 14.3459 13.6793 15.1665 12.667 15.1667H3.33301C2.32074 15.1665 1.50018 14.3459 1.5 13.3337V3.99969C1.50018 2.98743 2.32074 2.16686 3.33301 2.16669H12.667C13.6793 2.16686 14.4998 2.98743 14.5 3.99969V13.3337Z"
      fill="currentColor"
    />
    <path
      d="M14 6.16669C14.2761 6.16669 14.5 6.39054 14.5 6.66669C14.5 6.94283 14.2761 7.16669 14 7.16669H2C1.72386 7.16669 1.5 6.94283 1.5 6.66669C1.5 6.39054 1.72386 6.16669 2 6.16669H14Z"
      fill="currentColor"
    />
    <path
      d="M5.33333 9.33331H5.34"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M8 9.33331H8.00667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M10.6667 9.33331H10.6733"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M5.33333 12H5.34"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M8 12H8.00667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
  </svg>
);
